import gql from 'graphql-tag';
import {
  ALL_STATIONS_SLUG,
  ALL_GENRES_SLUG,
  ALL_MOODS_SLUG,
  ALL_PODCASTS_SLUG,
  SHOWS_ON_AIR_SLUG,
  ALL_SHOWS_SLUG,
} from 'globalConst/const';
import { IMAGE_FRAGMENT, MEDIA_FRAGMENT, CLIP_FRAGMENT, PODCAST_EPISODE_FRAGMENT } from './fragments';

export const getSearch = gql`
  query search($query: String!) {
    stations: collection(slug: "${ALL_STATIONS_SLUG}"){
      ... on StationCollection {
      id
      items(input: $query) {
        id
        type
        slug
        title
        shortTitle
        media {
          ...MediaFragment
        }
        images {
          ...ImageFragment
        }
        config {
          entries {
            key
            value
          }
        }
        playouts (limit: 1) {
          track {
            title
            artistName
          }
        }
      }
    }
  }
  
      
    genres: collection(slug: "${ALL_GENRES_SLUG}"){
      ... on TagCollection {
      id
      items(input: $query) {
        type
        slug
        title
        images {
          ...ImageFragment
        }
        config {
          entries {
            key
            value
          }
        }
      }
    }
  }
  
    moods: collection(slug: "${ALL_MOODS_SLUG}"){
      ... on TagCollection {
      id
      items(input: $query) {
        type
        slug
        title
        images {
          ...ImageFragment
        }
        config {
          entries {
            key
            value
          }
        }
      }
    }
  }
  
    podcasts: collection(slug: "${ALL_PODCASTS_SLUG}"){
      ... on PodcastCollection {
      id
      items (input: $query) {
        id
        type
        slug
        title
        subTitle
        images {
          ...ImageFragment
        }
        episodes(limit: 1) {
          ...PodcastEpisodeFragment
        }
      }
    }
  }
  
    liveShows: collection(slug: "${SHOWS_ON_AIR_SLUG}") {
      ... on ShowCollection {
      id
      items(input: $query) {
        type
        slug
        title
        media {
          ...MediaFragment
        }
        images {
          ...ImageFragment
        }
        config {
          entries {
            key
            value
          }
        }
        startTime
        endTime
        refs {
          targetType
          uri
        }
      }
    }
  }
  
    onDemands: collection(slug: "${ALL_SHOWS_SLUG}") {
      ... on ShowCollection {
      id
      items(input: $query) {
        type
        images {
          ...ImageFragment
        }
        config {
          entries {
            key
            value
          }
        }
        startTime
        endTime
        episodes (limit:100) {
          id
          title
          media {
            ...MediaFragment
          }
          publishDate
        }
      }
    }
  }
}
  ${IMAGE_FRAGMENT}
  ${MEDIA_FRAGMENT}
  ${PODCAST_EPISODE_FRAGMENT}
`;

export const getSearchClipCollection = gql`
  query searchClips($slug: String!, $query: String!, $limit: Int!, $nextToken: String) {
    clips: collection(slug: $slug) {
      ... on ClipCollection {
        id
        type
        slug
        title
        getClips(limit: $limit, input: $query, nextToken: $nextToken) {
          clips {
            ...ClipFragment
          }
          nextToken
          totalCount
        }
      }
    }
  }
  ${IMAGE_FRAGMENT}
  ${MEDIA_FRAGMENT}
  ${CLIP_FRAGMENT}
`;
